import Info from '@/components/subscriptiontypes/Info';
export default {
  name: 'SelectType',
  components: {
    Info
  },
  props: {
    types: Array,
    selected: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    selectSubType(type) {
      if (!this.isSelectMode) {
        return false;
      }
      this.$emit('select', type);
    }
  },
  computed: {
    isSelectMode() {
      return this.selected !== null;
    },
    hasSelection() {
      return this.selected !== null && this.selected && this.selected.id > 0;
    }
  },
  filters: {
    /** @returns {String} */
    billingType: function (val) {
      return val > 1 ? 'Billed Annually Until Cancellation' : val ? 'Billed Monthly Until Cancellation' : 'One Time Payment';
    }
  }
};